import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { alertActions } from '../../../../store/actions';

const CertificateAddDoc = props => {
  const [ fileList, setFileList ] = useState([]);
  const fileRef = React.useRef(new Array(10));
  const [ tempIdx, setTempIdx ] = useState(0);

  useEffect(() => {
    props.getAddList(fileList);
  }, [fileList]);

  // 줄추가시
  const addRow = () => {
    // 임시로 첨부파일 갯수 10개로 막아놓음
    if (tempIdx > 9) {
      props.error({message: '파일은 최대 10개까지만 추가 가능합니다.'});
      return;
    }

    let emptyList = [];

    emptyList.push({
      docKey: tempIdx,
      docFileName: '',
      docFile: '',
    });

    setFileList([
      ...fileList,
      ...emptyList
    ])

    setTempIdx(tempIdx + 1)
  }

  // 줄제거시
  const deleteRow = (docKey) => {
    let changeList = fileList.filter((file) => file.docKey !== docKey);

    setTempIdx(changeList.length);
    setFileList(changeList);
  }

  const setFile = (e, i) => {
    if (e.target?.files.length < 1) return;

    fileList[i] = {
      docFileName: e.target?.files[0].name,
      docFile: e.target?.files[0],
      docKey: e.target.id
    }

    setFileList([...fileList]);
  }

  return (
    <>
      <div className="detail-table-box">
        <div className="detail-title">첨부문서 {/* 2021.07.09 하단 버튼으로 변경 <button className="btn btn-add" onClick={addRow}>파일추가</button> */}</div>

        <div className="detail-table-scroll">
          <div className="inner">
            <div className="scroll">
              <div className="row">
                <ul className="flex-col">
                  {
                    fileList?.map((file, index) => (
                      <li key={index} className="flex-sb w-full file-add">
                        <button className="btn btn-del m-r-10" onClick={() => deleteRow(file.docKey)}>-</button>
                        <label htmlFor={file.docKey}>
                          {file.docFileName? file.docFileName : "파일을 입력하세요"}
                        </label>
                        <span className="text" onClick={()=> fileRef.current[index].click()}>파일첨부</span>
                        <input
                          title="첨부파일"
                          type="file"
                          ref={ref =>fileRef.current[index] = ref}
                          name="docFile"
                          id={file.docKey}
                          className="upload-hidden"
                          accept=".pdf, .png, .jpg, .gif"
                          onChange={(e) => setFile(e, index, file.docKey)}
                        />
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
            <div className="btn-area t-line"><button className="btn btn-full btn-add2" onClick={addRow}>파일추가</button></div>            
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
  }
}

const actionCreators = {
  error: alertActions.error,
}

export default connect(
  mapStateToProps,
  actionCreators
)(CertificateAddDoc)